<template>
  <div id="app">
    <Main msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import Main from './components/Main.vue'

export default {
  name: 'app',
  components: {
    Main
  },
}
</script>

<style>

@import './assets/materialdesignicons.css'; 

@font-face {
    font-family: 'Play';
    src: url('./assets/Play.woff2') format('woff2'),
        url('./assets/Play.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}
#app {
  font-family: Play;
}
</style>
